import { css } from '@emotion/css';

const FONT = {
  titillium: 'Titillium Web, PingFang SC, sans-serif',
  roboto: 'Roboto, PingFang SC, sans-serif',
};

export default FONT;
export const font12 = css`
  font-size: 12px;
`;

export const font14 = css`
  font-size: 14px;
`;

export const font16 = css`
  font-size: 16px;
`;

export const font18 = css`
  font-size: 18px;
`;

export const font20 = css`
  font-size: 20px;
`;

export const font22 = css`
  font-size: 22px;
`;

export const font24 = css`
  font-size: 24px;
`;

export const font26 = css`
  font-size: 26px;
`;

export const font28 = css`
  font-size: 28px;
`;

export const font32 = css`
  font-size: 32px;
`;

export const font36 = css`
  font-size: 36px;
`;

export const font40 = css`
  font-size: 40px;
`;

export const font42 = css`
  font-size: 42px;
`;

export const font64 = css`
  font-size: 64px;
`;

export const fontW700 = css`
  font-weight: 700;
`;

export const fontW600 = css`
  font-weight: 600;
`;

export const fontW500 = css`
  font-weight: 500;
`;

export const fontW400 = css`
  font-weight: 400;
`;
